<template>
  <div id="app">
    <NavBar :showNav="showNav"/>
    <admin-nav v-if="uId && this.$router.currentRoute.path.split('').splice(0,6).join('') === '/admin'"/>
    <router-view @darkNav="showNav = true" @whiteNav="showNav = false"/>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import AdminNav from '@/components/Items/AdminNav';
  import NavBar from './components/Items/NavBar';
  export default {
    components: { AdminNav, NavBar },
    computed: {
      ...mapState('auth', ['uId'])
    },
    metaInfo: {
      meta: [
        { name: "author", content: "Светлана Рамбелли" },
        { name: 'keywords', content: 'Психология, консультации, консультация, Светлана Рамбелли, Светлана, Рамбелли' },
        { name: 'description', content: 'Психологическое консультирование взрослых онлайн' },
        { property: 'og:title', content: 'Практикующий психолог' },
        { property: 'og:site_name', content: 'Практикующий психолог' },
        { property: 'og:description', content: 'Психологическое консультирование взрослых онлайн' },
        { property: 'og:image', content: `${require('@/assets/header.png')}` }
      ],
    },
    data() {
      return {
        showNav: false
      }
    },
  }
</script>
<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@400;500;600;700&family=Nunito:wght@300;400;600&family=Raleway:wght@300;400;500;600;700&display=swap');
  //font-family: 'Comfortaa', cursive;
  //font-family: 'Nunito', sans-serif;
  //font-family: 'Raleway', sans-serif;
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    text-decoration: none;
  }
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  text-align: center;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
  body {
    .button {
      transition: .5s;
    }
    #nav2 a {
      transition: .3s;
    }
    #nav2 .nav-item .nav-link:hover {
      color: #0b97d3 !important;
    }
    #nav a {
      transition: .3s;
    }
    #nav a:hover {
      color: #0b97d3 !important;
    }
    .button:hover {
      background-color: #0b97d3 !important;
    }
    .form1 .form input.form-control.is-invalid, .form1 .form textarea.is-invalid {
      border: 1px solid red !important;
    }
    input.is-invalid, textarea.is-invalid {
      border-color: red !important;
    }
    .pagination {
      margin-bottom: 32px;
    }
    .page-link {
      color: #7e7e7e;
      font-family: 'Nunito', sans-serif !important;
    }
    .page-item.active .page-link {
      z-index: 3;
      color: #5ec8f5;
      background-color: #fff;
      border-color: #fff;
    }
    .pagination .page-item:nth-last-child(2), .pagination .page-item:last-child {
      margin-left: 8px;
      a.page-link {
        border: 1px solid #dee2e6 !important;
      }
      span.page-link {
        border: 1px solid #dee2e6 !important;
      }
    }
    .pagination .page-item:nth-child(2), .pagination .page-item:first-child {
      margin-right: 8px;
      span.page-link, a.page-link {
        border: 1px solid #dee2e6 !important;
      }
    }
    .pagination .page-item {
      a {
        border: 1px solid #fff;
      }
    }
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }
</style>
